/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculatePositionsResultDto
 */
export interface CalculatePositionsResultDto {
    /**
     * 
     * @type {number}
     * @memberof CalculatePositionsResultDto
     */
    positionsCount: number;
}

/**
 * Check if a given object implements the CalculatePositionsResultDto interface.
 */
export function instanceOfCalculatePositionsResultDto(value: object): value is CalculatePositionsResultDto {
    if (!('positionsCount' in value) || value['positionsCount'] === undefined) return false;
    return true;
}

export function CalculatePositionsResultDtoFromJSON(json: any): CalculatePositionsResultDto {
    return CalculatePositionsResultDtoFromJSONTyped(json, false);
}

export function CalculatePositionsResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculatePositionsResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'positionsCount': json['positionsCount'],
    };
}

export function CalculatePositionsResultDtoToJSON(value?: CalculatePositionsResultDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'positionsCount': value['positionsCount'],
    };
}

